/* Mr Pixel — back to top. */
(function () {
  'use strict';

  function toTop() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  }

  function init() {
    var inline = document.querySelector('[data-mp-to-top-inline]');
    if (inline) inline.addEventListener('click', toTop);

    var button = document.querySelector('[data-mp-to-top]');
    if (!button) return;

    var threshold = parseInt(button.dataset.offset || '600', 10) || 600;
    var scrolled = false;
    var footerNear = false;
    var applied = null;

    function apply() {
      var shouldShow = scrolled && !footerNear;
      if (shouldShow === applied) return;
      applied = shouldShow;
      button.classList.toggle('is-visible', shouldShow);
      button.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      button.tabIndex = shouldShow ? 0 : -1;
    }

    var footer = document.querySelector('.shopify-section-group-footer-group')
      || document.querySelector('.mp-to-top-inline-wrap')
      || document.querySelector('footer');

    function footerIsNear() {
      if (!footer) return false;
      return footer.getBoundingClientRect().top <= window.innerHeight;
    }

    function onScroll() {
      scrolled = window.scrollY > threshold;
      footerNear = footerIsNear();
      apply();
    }

    button.addEventListener('click', toTop);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function relocate() {
    var wrap = document.querySelector('.mp-to-top-inline-wrap');
    if (!wrap || wrap.dataset.mpMoved) return;

    var row = document.querySelector("[class*='footer-bottom-payments-wrapper-']");
    if (!row) return;

    var payments = row.querySelector("[class*='footer-payments-']");
    var before = payments ? payments.nextSibling : row.firstChild;

    row.insertBefore(wrap, before);
    wrap.dataset.mpMoved = '1';
  }

  function boot() {
    relocate();
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
